import _ from 'underscore';
import {
    TOGGLE_LEAD,
    IS_LOADING,
    USER_TICKETS_FETCHED,
    USER_SELECT_TICKET,
    USER_UNSELECT_TICKET,
    FETCH_SESSION_FOR_REGISTRATION_BY_TICKET,
    FETCH_SESSION_REGISTERED_BY_TICKET,
    TICKET_SELECTION_POP_ACTION,
    SAVE_A_SEAT_REQUEST,
    SAVE_A_SEAT_REQUEST_END,
    SAVE_A_SEAT_ERROR
} from '../constants/ActionTypes';

export function getInitialState() {
    return {
        isLoading: false,
        tickets: [],
        selectedTicketsIds: [],
        sessionForRegistration: {},
        overlappingSessions: {},
        ticketRule: null,
        sessionRegisteredOn: {},
        ticketSelectionOpen: false,
        saveASeatRequests: {},
        saveASeatErrors: {}
    };
}
const matchSelectedTicketsIds = (tickets, selectedTicketsIds ) =>
    (tickets || []).map(({id}) => id).filter(id => selectedTicketsIds && selectedTicketsIds.includes(parseInt(id)));

const removeProperty = prop => ({ [prop]: _, ...rest }) => rest;

function UserProfilePageReducer(state = getInitialState(), action = null) {
    let person;
    switch (action.type) {
    case TOGGLE_LEAD :
        person = Object.assign({}, state.person);
        person.myLead = !person.myLead;
        return Object.assign({}, state, {person: person});
    case IS_LOADING:
        return Object.assign({}, state, {
            isLoading: action.isLoading
        });
    case USER_TICKETS_FETCHED: {
        const { tickets } = action;
        const { tmpSelectedTicketsIds } = state;
        return {
            ...state,
            tickets,
            selectedTicketsIds: matchSelectedTicketsIds(tickets, tmpSelectedTicketsIds)
        };
    }
    case USER_SELECT_TICKET: {
        const { tickets } = state;
        return {
            ...state,
            tmpSelectedTicketsIds: action.selectedTicketsIds,
            selectedTicketsIds: matchSelectedTicketsIds(tickets, action.selectedTicketsIds)
        };
    }
    case TICKET_SELECTION_POP_ACTION: {
        return {
            ...state,
            ticketSelectionOpen: !state.ticketSelectionOpen
        };
    }
    case FETCH_SESSION_FOR_REGISTRATION_BY_TICKET: {
        return {
            ...state,
            sessionForRegistration: {
                ...state.sessionForRegistration,
                ...{[action.ticketId]: action.sessions.sessions}
            },
            overlappingSessions: {
                ...state.overlappingSessions,
                ...{[action.ticketId]: action.sessions.overlappingSessions}
            },
            ticketRule: {
                ...state.ticketRule,
                ...{[action.ticketId]: action.sessions.ticketRule}
            }
        };
    }
    case FETCH_SESSION_REGISTERED_BY_TICKET: {
        return {
            ...state,
            sessionRegisteredOn: {
                ...state.sessionRegisteredOn,
                ...{[action.ticketId]: action.sessions}
            }
        };
    }
    case USER_UNSELECT_TICKET: {
        const removeTicket = removeProperty(action.ticketId);
        return {
            ...state,
            sessionForRegistration: removeTicket(state.sessionForRegistration),
            overlappingSessions: removeTicket(state.overlappingSessions),
            ticketRule: removeTicket(state.ticketRule),
            sessionRegisteredOn: removeTicket(state.sessionRegisteredOn),
            tmpSelectedTicketsIds: action.selectedTicketsIds,
            selectedTicketsIds: action.selectedTicketsIds
        };
    }
    case SAVE_A_SEAT_REQUEST:{
        const ticketsIds = _.union(state.saveASeatRequests[action.sessionId], [action.ticketId]);
        return {
            ...state,
            saveASeatRequests: {
                ...state.saveASeatRequests,
                ...{[action.sessionId]: ticketsIds}
            },
            saveASeatErrors: {
                ...state.saveASeatErrors,
                [action.sessionId]: {
                    ...state.saveASeatErrors[action.sessionId],
                    [action.ticketId]: null
                }
            }
        };
    }
    case SAVE_A_SEAT_REQUEST_END:{
        const ticketsIds = _.without(state.saveASeatRequests[action.sessionId], action.ticketId);
        return {
            ...state,
            saveASeatRequests: {
                ...state.saveASeatRequests,
                ...{[action.sessionId]: ticketsIds}
            }
        };
    }
    case SAVE_A_SEAT_ERROR: {
        const { sessionId, ticketId, error } = action;
        return {
            ...state,
            saveASeatErrors: {
                ...state.saveASeatErrors,
                [sessionId]: {
                    ...state.saveASeatErrors[sessionId],
                    [ticketId]: error || null
                }
            }
        };
    }
    default:
        return state;
    }
}

export default UserProfilePageReducer;
